import React, { useEffect, useRef } from 'react';
import { LogMessage } from '../types';
import './LogPanel.css';

interface LogPanelProps {
  messages: LogMessage[];
}

export const LogPanel: React.FC<LogPanelProps> = ({ messages }) => {
  const logEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Auto-scroll to bottom when new messages arrive
    logEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const getMessageTypeClass = (type: string) => {
    switch (type) {
      case 'init': return 'log-init';
      case 'gmt': return 'log-gmt';
      case 'grid': return 'log-grid';
      case 'css': return 'log-css';
      case 'data': return 'log-data';
      case 'error': return 'log-error';
      case 'system': return 'log-system';
      default: return 'log-default';
    }
  };

  return (
    <div className="log-panel">
      <div className="log-header">
        <h3>System Logs</h3>
        <div className="log-count">
          {messages.length} messages
        </div>
      </div>
      
      <div className="log-container">
        {messages.map((message, index) => (
          <div
            key={index}
            className={`log-message ${getMessageTypeClass(message.type)}`}
          >
            <span className="log-timestamp">
              {new Date(message.timestamp).toLocaleTimeString()}
            </span>
            <span className="log-type">[{message.type}]</span>
            <span className="log-content">{message.content}</span>
          </div>
        ))}
        <div ref={logEndRef} />
      </div>
    </div>
  );
}; 